<template>
  <div>
    <el-dialog v-dialogDrag title="表格设置" :visible.sync="dialogVisible" width="60%" @open="openDialog">
      <el-table ref="table" id="itxst" :row-key="row => row.prop" :data="tableData" stripe border> 
        <el-table-column v-for="item in tableColumns" :key="item.prop" :prop="item.prop" :label="item.label" :width="item.width">
          <template slot-scope="scope">
              <my-render v-if="item.render" :sc="scope" :row="scope.row" :render="item.render"></my-render>
              <span v-else>{{ scope.row[item.prop] }} </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import myRender from "./myRender.vue"
import Sortable from 'sortablejs';

export default {
  name: "customTableDialog",
  components: { myRender },
  props: {
    /** 动态列数据的表名 如:报价单  */
    tableType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      dialogVisible:false,
      tableColumns: [
        { 
          label: '列名称', 
          prop: 'Label',
          render: (h, param) => {
            const elem = 
            <div>
              <el-input v-model={param.row.Label}></el-input>
            </div>
            return (elem);
          }
        },
        { 
          label: '宽度',
          prop: 'Width',
          render: (h, param) => {
            const elem = 
            <div>
              <el-input v-model={param.row.Width } placeholder="请输入宽度(格式:180px)"></el-input>
            </div>
            return (elem);
          }
        },
        { 
          label: '对齐方式',
          prop: 'Align',
          render: (h, param) => {
            const elem = 
            <div>
              <el-select v-model={param.row.Align } placeholder="请选择对齐方式">
                <el-option label="左对齐" value="left"></el-option>
                <el-option label="居中对齐"value="center"></el-option>
                <el-option label="右对齐" value="right"></el-option>
              </el-select>
            </div>
            return (elem);
          }
        },
        { 
          label: '显示',
          prop: 'IsShow',
          render: (h, param) => {
            const elem = 
            <div>
              <el-switch v-model={param.row.IsShow} active-color="#13ce66"></el-switch>
            </div>
            return (elem);
          }
        },
        { 
          label: '拖拽排序列', 
          prop: 'Order',
          width: '105px',
          align: 'center',
          
          render: (h, param) => {
            const elem = 
            <div class={{'my-handle': true}}>
              <i class="el-icon-sort"></i>
            </div>
            return (elem);
          }
        },
      ],
      tableData:[],
    }
  },
  methods: {
    async openDialog() {
      this.sortable()
      this.dialogVisible = true;
      const res = await this.FieldSettingApi.list({Type: this.tableType})
      this.tableData = res.Data;
    },
    sortable(){
      this.$nextTick(() => {
        var el = this.$refs.table.$el.querySelector(".el-table__body-wrapper tbody");
        let that = this
        let options = {
          animation: 300,
          handle:".my-handle",
          /** 拖拽结束的回调函数 */
          onEnd: function (evt) {
            const oldIndex = evt.oldIndex; // 被拖拽的元素的索引
            const newIndex = evt.newIndex; // 拖拽到的位置的索引
            that.tableData.splice(newIndex, 0, that.tableData.splice(oldIndex, 1)[0]);
            const newArray = that.tableData
            that.tableData = []
            that.$nextTick(function () {
              that.tableData = newArray
            })
          },
        };
        Sortable.create(el, options); 
      });
    },
    onSave(){
      this.dialogVisible = false
      this.FieldSettingApi.save({Type: this.tableType,Settings: this.tableData}).then((res) => {
        if (res.Code === 0) {
          this.$emit('onSave',this.tableData)
        }
      })
    }
  }
};
</script>